<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bgg-pattern-{pattern}-{dark|light}</code> to apply a pattern.</p>
<code-well-header>
  <dt-stack direction="row" align="center" class="d-w100p d-h32 d-bar4 d-bgg-to-br d-ba d-bc-default d-bgc-moderate d-bgg-pattern d-bgg-pattern-slanted-stripes-dark d-fc-primary">Ted's Call Center</dt-stack>
  <dt-stack direction="row" align="center" class="d-w100p d-h32 d-bar4 d-bgg-to-br d-ba d-bc-default d-bgc-moderate d-bgg-pattern d-bgg-pattern-chevrons-dark">Vicky's Department</dt-stack>
</code-well-header>
<div class="language-html" data-highlighter="prismjs" data-ext="html"><pre v-pre><code class="language-html"><span class="line"></span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>... d-bgg-pattern d-bgg-pattern-slanted-stripes-dark<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>...<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span></span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>... d-bgg-pattern d-bgg-pattern-dots-circles-light<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>...<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span></span>
<span class="line"></span></code></pre>
</div><h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody v-for="c in ['dark', 'light']">
      <tr v-for="i in ['blob', 'chevrons', 'crosses', 'crosshatch', 'dot-dash', 'dots-circles', 'horz-stripes', 'slanted-stripes', 'steps', 'stripe']">
        <th scope="row" class="d-code--sm d-docsite-code">.d-bgg-pattern-{{ i }}-{{ c }}</th>
        <td>
          <dt-stack direction="row" justify="between" align="center">
            <div class="d-fl-grow1 d-code--sm">
              --bgg-pattern: --bgg-pattern-{{ i }}-{{ c }};
            </div>
            <div
              class="d-w24 d-h24 d-bgg-pattern d-ba d-bc-black-900 d-bar4"
              :class="[
                  {'d-bgc-neutral-white': c === 'dark'},
                  {'d-bgc-neutral-black': c === 'light'},
                  `d-bgg-pattern-${i}-${c}`
              ]"
            >
            </div>
          </dt-stack>
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


